export default __webpack_public_path__ + "static/media/github-brands.bd7e0828.png";